import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import {
  SaveBtn,
  addForecastSpecificationDataType,
  addForecastSpecificationDataTypeOptions,
  cumulative,
  endYr,
  simulate,
  strtYr,
  unitDropdown,
  unitTooltip,
  simulateValue,
  addForecastSpecificationStartYearGreaterThanMRY,
  addForecastSpecificationStartYearLessThanFEY,
  endYearGreaterThanFEYear,
  endYearLessThanStartYear,
  ruleName,
  decimalsNotAllowedError,
  relativePercentageError,
  relativeExtendEmitionFactorError,
  activityDataRelativeExtendError,
  only2DecimalsAllowed,
  negativeNotallowed,
  emissionArray,
  targetHierarchy,
  emisFactorUnit,
  actDataUnit,
  emisFactValue,
  actDataValue,
  targetHierarchyValues,
  maxlimitExceeded,
  onlyNumbersAllowed,
  ruleNameTooltip,
  cumulativeTooltip,
  emissionsStartyearTooltip,
  emissionsEndYeartooltip,
  targetHierarchyTooltip,
  activityDataValueTooltip,
  emissionFactorTooltip,
  activityDataRelativeError,
  ruleDescription,
  addGMPSource,
  edittype,
  editTypeOptions,
  absoluteorRelative,
  projectDetailsBusinessRulesChangeType,
  editExtend,
  cumulativedropdown,
  aDValidationError,
  eFValidationError,
  transferOrCopy,
  transferCopyOptions,
  defineNewHrchy,
  ruleDescTooltip,
  sourceRuleTooltip,
  editTypeTooltip,
  forecastDataTypeTooltip,
  changeTypeTooltip,
  transferADTooltip,
  activityUnitTooltip,
  emissionFactorunitTooltip,
  emissionsValuetooltip1,
  ruleNameUniqueMsg,
  ruleNameRequiredError,
  selectGMPUnit,
  createNewGMPUnit,
  SearchNewGMPUnit,
  simulateDecimalNumberRegExp,
  onlyNumbersRegExp,
  onlyPositiveRegExp,
  addGMPDependencyOptions,
  EMISSION_EXTEND_RELATIVE,
  EMISSION_VALUE_ABSOLUTE_INFO,
  EMISSION_CUMULATIVE_ABSOLUTE_EF_INFO,
  DataSelection,
  ruleNameRegexp,
  ruleDescRegexp,
  ruleNameLength,
  ruleDescLength,
  maxLength100,
  maxLength4000,
  maxLength2000,
  maxLength200,
  commonError,
  wafErrorMessage,
  ruleSourceLength,
  ruleSourceRegexp,
  financialParamDataUnitRegExp,
  dataUnitLength,
  adDataUnitError
} from "../../../util/constants";
import { Select } from "../../CommonUIComponents/Select/Select";
import {
  AreaSeacrhIcon,
  EmissionIcon,
  SaveIcon,
  SimulateIcon,
  WarningIconOrange,
} from "../../../icons";
import { Button } from "../..";
import { Tooltip } from "../../CommonUIComponents/Tooltip/Tooltip";
import MultiSelectCreatableOption from "../../CommonUIComponents/MultiSelectCreatableOption";
import { Input } from "../../CommonUIComponents/Input/Input";
import { useDispatch, useSelector } from "react-redux";
import {
  setSimulateDataOnTable,
  setSimulateFlag,
  setGraphSimulateFlag,
  setSimulateDataOnGraph,
  setReduceDefautViewData,
  setTogglechecked,
  resetManualEditRules,
  setM3Step2Loader,
  setIsManualEdit,
  setSelectedDataType,
  setExtendNewHierarchy,
  setHierarchialData,
  setselectedUIAllFilters,
  setHasDataSelectionApplied,
} from "../../../store/slices/projectSlice";
import {
  getM3TableGraphData,
  manualEditM3Step2,
  SaveM3Step2ReplaceData,
  getUniqueProjectRuleFlag,
  getDistinctADUnit
} from "../../../store/services/project.service";
import { LoadingIndicatorEmbed } from "../../CommonUIComponents/LoadingIndicator/LoadingIndicatorEmbed";
import { TextArea } from "../../CommonUIComponents/TextArea/TextArea";
import { EmissionFilterModal } from "../EmissionsFilterModal/EmissionFilterModal";
import "../Emissions.scss";
import { ExtendModal } from "./ExtendModal";
import { getReplaceHierarchyData } from "../../../store/services/engagement.service";
import { setWafErrorFlag } from "../../../store/slices/projectSlice";

// Constant for info message styling
const INFO_MESSAGE_STYLE = {
  color: '#c4c4c4',
  lineHeight: '100%',
  letterSpacing: '-.1px'
};

const FILTER_KEYS = [
  "scope",
  "category_level1",
  "category_level2",
  "category_level3",
  "region_level1",
  "region_level2",
  "region_level3",
  "entity_level1",
  "entity_level2",
  "entity_level3",
  "entity_level4",
  "custom_specification1",
  "custom_specification2",
  "custom_specification3",
];

export function SimulateFields() {
  const dispatch = useDispatch();
  const engagement = useSelector((state) => state.engagement.engagement);
  const project = useSelector((state) => state.project.project);
  const user = useSelector((state) => state.user.user);
  const filtersPayload = useSelector(
    (state) => state.project.appliedFilterPayload
  );
  const reduceDefaultViewData = useSelector(
    (state) => state.project.defaultViewData
  );
  const selectedUIAllFilters = useSelector(
    (state) => state?.project?.selectedUIAllFilters
  );

  const [dataType, setDataType] = useState("Activity data");
  const [cumlative, setCumulative] = useState("");
  const [unitSelected, setUnit] = useState();
  const [value, setValue] = useState("");
  const [startYear, setStartYear] = useState("");
  const [endYear, setEndYear] = useState("");
  const [valueErrorMessage, setValueErrorMessage] = useState("");
  const [valueError, setValueError] = useState(false);
  const [startYearErrorMessage, setStartYearErrorMessage] = useState("");
  const [endYearErrorMessage, setEndYearErrorMessage] = useState("");
  const decimalNumberRegExp = simulateDecimalNumberRegExp;
  const [showstartYearError, setShowStartYearError] = useState(false);
  const [showendYearError, setShowEndYearError] = useState(false);
  const [rule, setRuleName] = useState("");
  const [ruleDesc, setRuleDesc] = useState("");
  const [editType, setEditType] = useState("Batch edit");
  const [isSimulateBtnDisable, setSimulateBtnDisable] = useState(true);
  const [simulateLoader, setSimulateloader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [trgtHrchy, setTrgtHrchy] = useState("");
  const [activityDataValue, setActivityDataValue] = useState("");
  const [emissionFactorValue, setEmissionFactorValue] = useState("");
  const [activityDataUnit, setActivityDataUnit] = useState("");
  const [emissionFactorUnit, setEmissionFactorUnit] = useState("");
  const [trnsfrOrCopy, setTransferCopy] = useState("");
  const [activityDataValueErrorMessage, setActivityDataValueErrorMessage] =
    useState("");
  const [isActivityDataValueError, setisActivityDataValueError] =
    useState(false);
  const [emissionFactorValueErrorMessage, setEmissionFactorValueErrorMessage] =
    useState("");
  const [isEmissionFactorValueError, setIsEmissionFactorValueError] =
    useState(false);
  const [activityDataUnitErrorMessage, setActivityDataUnitErrorMessage] =
    useState("");
  const [isActivityDataUnitError, setIsActivityDataUnitError] =
    useState(false);
  const [replaceChange, setReplaceChangeType] = useState("Edit");
  const [lockedData, setLock] = useState();
  const [lockedBy, setLockedby] = useState();
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isExtendModalOpen, setExtendModalOpen] = useState(false);
  const hasAppliedDataSelection = useSelector(
    (state) => state.project.hasDataSelectionApplied
  );
  const [source, setSource] = useState("");
  const dropdownMetadataFinal = useSelector(
    (state) => state.project.dropdownData
  );
  const [metaData, setMetadata] = useState();
  const validationFlag = useSelector(
    (state) => state.project.unitValidationFlag
  );
  const [showUnitValidationError, setUnitValidationError] = useState(false);
  const hasBlockingUnitValidationError = showUnitValidationError && project?.projectType !== 3;
  const [isExtendedRuleCreated, setIsExtendedRuleCreated] = useState(false);

  // Helper function to check if Emission Factor has validation errors
  const hasEFValidationError = () => {
    // For project type 3, don't apply this logic
    if (project?.projectType === 3) {
      return validationFlag?.isDuplicate_EF === "Y";
    }
    // For project types 1 and 2, check both isDuplicate_EF and eF_VALUE_COUNT
    // Only for Absolute unit selection (not Relative)
    if (unitSelected === "Absolute" && (project?.projectType === 1 || project?.projectType === 2)) {
      return validationFlag?.isDuplicate_EF === "Y" || validationFlag?.eF_VALUE_COUNT === "Y";
    }
    // Default to only checking isDuplicate_EF
    return validationFlag?.isDuplicate_EF === "Y";
  };

  /**
   * Helper function to determine if Extend mode fields should be disabled
   * this function only handles disable state logic
   * @returns {boolean} - true if field should be disabled, false otherwise
   * In Edit mode: Fields are disabled based on validation flags (duplicate units, etc.)
   * In Extend mode: Fields should never be disabled by validation flags since we're creating NEW data
   */
  const shouldDisableExtendField = () => {
    // In Extend mode, validation flags don't apply - we're creating new hierarchy data
    if (replaceChange === "Extend") {
      return false;
    }
    // In Edit mode, apply validation flag logic based on data type
    if (dataType === addForecastSpecificationDataTypeOptions[0]) {
      return validationFlag?.isDuplicate_AD === "Y";
    }
    return hasEFValidationError();
  };

  /**
   * Helper function to check if "Define new target hierarchy" button should be disabled
   * @returns {boolean} - true if button should be disabled
   */
  const shouldDisableDefineHierarchyButton = () => {
    // Always check if target hierarchy is selected and filters are applied
    const hasRequiredSelections = trgtHrchy !== "" && checkIfFilterChanged();
    // In Extend mode, only check required selections (not validation flags)
    if (replaceChange === "Extend") {
      return !hasRequiredSelections;
    }
    // In Edit mode, also check validation flags
    return !hasRequiredSelections || shouldDisableExtendField();
  };
  
  const manualEditRules = useSelector((state) => state.project.manualEditRules);
  const newExtendhierarchy = useSelector(
    (state) => state.project.extendNewHierarchy
  );
  const selectedExtendHierarchy = useSelector(
    (state) => state.project.selectedExtendHierarchy
  );
  const [ruleNameErrorMessage, setRuleNameErrorMessage] = useState("");
  const [ruleDescErrorMessage, setRuleDescErrorMessage] = useState("");
  const [ruleSourceErrorMessage, setRuleSourceErrorMessage] = useState("");
  const [ruleNameError, setRuleNameError] = useState(false);
  const [avilableGmpUnit, setAvilableADUnits] = useState([]);
  const [isChange, setIsChange] = useState(true);
  const lastCheckedRuleName = useRef("");
  const latestRuleNameRef = useRef("");

  const wafErrorFlag = useSelector((state) => state.project.wafErrorFlag);
  const [wafErrorMessageState, setWafErrorMessageState] = useState("");

  // Memoizing this condition to avoid recalculation on every render
  const shouldShowAbsoluteEFInfo = useMemo(() => {
    return (
      (project.projectType === 1 || project.projectType === 2) &&
      replaceChange === "Edit" &&
      editType === "Batch edit" &&
      dataType === addForecastSpecificationDataTypeOptions[1] &&
      unitSelected === "Absolute"
    );
  }, [project.projectType, replaceChange, editType, dataType, unitSelected]);

  const hasAnySelectedFilter = useMemo(
    () => FILTER_KEYS.some((key) => selectedUIAllFilters?.[key]?.length > 0),
    [selectedUIAllFilters]
  );

  useEffect(() => {
    latestRuleNameRef.current = rule;
  }, [rule]);

  useEffect(() => {
    if (wafErrorFlag) {
      setWafErrorMessageState(wafErrorMessage);
    }
  }, [wafErrorFlag]);

  //Check for the Simulate and Save button validation
  useEffect(() => {
    checkSimulateEnableValidation();
  }, [
    dataType,
    cumlative,
    unitSelected,
    value,
    startYear,
    endYear,
    rule,
    editType,
    manualEditRules,
    activityDataUnit,
    activityDataValue,
    emissionFactorValue,
    trgtHrchy,
    newExtendhierarchy,
    validationFlag,
    ruleNameError,
    ruleDescErrorMessage,
    ruleSourceErrorMessage,
    isActivityDataUnitError,
    selectedUIAllFilters,
    showUnitValidationError,
    replaceChange,
    trnsfrOrCopy,
    emissionFactorUnit,
    isActivityDataValueError,
    isEmissionFactorValueError,
    hasAppliedDataSelection,
    valueError,
    showstartYearError,
    showendYearError,   
    selectedExtendHierarchy,
    project.projectType,
    wafErrorFlag,
  ]);

  //Set the data Type selection
  useEffect(() => {
    if (project.projectType === 3) {
      dispatch(setSelectedDataType({ dataType: addGMPDependencyOptions[1] }));
      setDataType(addGMPDependencyOptions[1]);
    } else {
      dispatch(setSelectedDataType({ dataType: addGMPDependencyOptions[0] }));
      setDataType(addGMPDependencyOptions[0]);
    }
  }, [project.projectType]);

  //Code to get the dropdownMetadata payload
  useEffect(() => {
    setMetadata(dropdownMetadataFinal);
  }, [dropdownMetadataFinal]);

  //Unit Validation flag  error message display logic
  useEffect(() => {
    // Early return: Don't show warning if data selection hasn't been applied yet
    if (!hasAppliedDataSelection) {
      setUnitValidationError(false);
      return;
    }
    
    // Only show warning if unit is explicitly set to "Absolute"
    if (unitSelected !== "Absolute") {
      setUnitValidationError(false);
      return;
    }

    // Helper function to check if validation flags indicate errors
    const hasValidationError = () => {
      // Activity Data: Show warning if isDuplicate_AD is "Y"
      if (dataType === addForecastSpecificationDataTypeOptions[0]) {
        return validationFlag?.isDuplicate_AD === "Y";
      }

      // Emission Factor: Show warning if isDuplicate_EF or eF_VALUE_COUNT is "Y"
      if (dataType === addForecastSpecificationDataTypeOptions[1]) {
        return hasEFValidationError();
      }

      // No data type selected: Show warning if any validation flag is set
      return validationFlag?.isDuplicate_AD === "Y" || hasEFValidationError();
    };

    setUnitValidationError(hasValidationError());
  }, [validationFlag, dataType, hasAppliedDataSelection, unitSelected]);

  //resetting Fields after every data selection

  useEffect(() => {
    if(isExtendedRuleCreated){
    resetSimulatefields();
    setIsExtendedRuleCreated(false);
    }    
  }, [reduceDefaultViewData]);

  const checkIfFilterChanged = () => {
    return hasAnySelectedFilter;
  }

  // To get the distinct list of activity data unit
  useEffect(() => {
    async function GetProjectDistinctADUnitsFn() {
      const request = { engagementCode: engagement.engagementCode };
      const data = await getDistinctADUnit({ request });
      setAvilableADUnits(data);
    }
    if (engagement?.engagementCode) {
      GetProjectDistinctADUnitsFn();
    }
  }, [engagement?.engagementCode, dispatch]);

  // Validation for Value field
  const checkValueValidation = (value) => {
    if (
      (dataType === addGMPDependencyOptions[0] || dataType === addGMPDependencyOptions[1]) &&
      unitSelected === "Absolute"
    ) {
      if (value === "-") {
        setValueError(false);
        setValueErrorMessage("");
      } else if (!onlyNumbersRegExp.test(value)) {
        setValueErrorMessage(decimalsNotAllowedError);
        setValueError(true);
      } else {
        setValueError(false);
        setValueErrorMessage("");
      }
    }
    if (
      (dataType === addForecastSpecificationDataTypeOptions[0] ||
        dataType === addForecastSpecificationDataTypeOptions[1] ||
        dataType === addGMPDependencyOptions[1]) &&
      unitSelected === "Relative"
    ) {

      if (value === "" || value === "-") {
        setValueError(false);
        setValueErrorMessage("");
      } else if (value < -100 || value > 9999.99) {
        setValueErrorMessage(relativePercentageError);
        setValueError(true);
      } else if (!decimalNumberRegExp.test(value)) {
        setValueError(true);
        setValueErrorMessage(only2DecimalsAllowed);
      } else {
        setValueError(false);
        setValueErrorMessage("");
      }
    }
    if (dataType === addForecastSpecificationDataTypeOptions[1] && unitSelected === "Absolute") {
      setValueError(false);
      setValueErrorMessage("");
      if (value === "" || value === "-") {
        setValueError(false);
        setValueErrorMessage("");
      } else if (!decimalNumberRegExp.test(value)) {
        if (!decimalNumberRegExp.test(value)) {
          setValueErrorMessage(only2DecimalsAllowed);
          setValueError(true);
        } else if (!onlyNumbersRegExp.test(value)) {
          setValueErrorMessage(onlyNumbersAllowed);
          setValueError(true);
        }
      } else if (parseFloat(value) > 99999999999) {
        setValueErrorMessage(maxlimitExceeded);
        setValueError(true);
      } else {
        setValueError(false);
        setValueErrorMessage("");
      }
    }
  };

  // Start year validation check
  const checkStartYearValidation = (value) => {
    const mostRecentYear = engagement.mostRecentYear;
    if (value && parseFloat(value) <= mostRecentYear) {
      setStartYearErrorMessage(addForecastSpecificationStartYearGreaterThanMRY);
      setShowStartYearError(true);
    } else if (value && parseFloat(value) > engagement?.foreCastEndYear) {
      setStartYearErrorMessage(addForecastSpecificationStartYearLessThanFEY);
      setShowStartYearError(true);
    } else {
      setStartYearErrorMessage("");
      setShowStartYearError(false);
    }
  };

  // End year validation check
  const checkEndYearValidation = (value) => {
    const forecastEndYear = engagement.foreCastEndYear;
    if (value && parseFloat(value) > forecastEndYear) {
      setEndYearErrorMessage(endYearGreaterThanFEYear);
      setShowEndYearError(true);
    } else if (value && startYear && parseFloat(value) < startYear) {
      setEndYearErrorMessage(endYearLessThanStartYear);
      setShowEndYearError(true);
    } else {
      setEndYearErrorMessage("");
      setShowEndYearError(false);
    }
  };

  //  Activity data value validation for Replace Extend
  const checkActivityDataValue = (value) => {
    if (unitSelected === "Absolute") {
      if (value == "") {
        setActivityDataValueErrorMessage("");
        setisActivityDataValueError(true);
      } else if (!onlyPositiveRegExp.test(value)) {
        if (value < 0 || value === "-") {
          setActivityDataValueErrorMessage(negativeNotallowed);
          setisActivityDataValueError(true);
        } else if (!onlyPositiveRegExp.test(value)) {
          setActivityDataValueErrorMessage(decimalsNotAllowedError);
          setisActivityDataValueError(true);
        }
      } else if (value > 99999999999) {
        setActivityDataValueErrorMessage(maxlimitExceeded);
        setisActivityDataValueError(true);
      } else {
        setActivityDataValueErrorMessage("");
        setisActivityDataValueError(false);
      }
    } else {
      if (value === "") {
        setActivityDataValueErrorMessage("");
        setisActivityDataValueError(false);
      } else if (unitSelected === "Relative" && replaceChange === "Extend") {
        if (value < 0 || value > 9999.99) {
          setActivityDataValueErrorMessage(activityDataRelativeExtendError);
          setisActivityDataValueError(true);
        } else {
          setActivityDataValueErrorMessage("");
          setisActivityDataValueError(false);
        }
      } else if (value > 100) {
        setActivityDataValueErrorMessage(activityDataRelativeError);
        setisActivityDataValueError(true);
      } else if (!onlyPositiveRegExp.test(value)) {
        if (value > 100) {
          setActivityDataValueErrorMessage(activityDataRelativeError);
          setisActivityDataValueError(true);
        } else if (value < 0) {
          setActivityDataValueErrorMessage(negativeNotallowed);
          setisActivityDataValueError(true);
        } else if (!decimalNumberRegExp.test(value)) {
          setActivityDataValueErrorMessage(only2DecimalsAllowed);
          setisActivityDataValueError(true);
        } else {
          setActivityDataValueErrorMessage("");
          setisActivityDataValueError(false);
        }
      } else {
        setActivityDataValueErrorMessage("");
        setisActivityDataValueError(false);
      }
    }
  };

  // Emission factor value validations for Replace Extend scenario
  const checkEmissionFactorValue = (value) => {
    if (unitSelected === "Absolute") {
      if (value === "") {
        setEmissionFactorValueErrorMessage("");
        setIsEmissionFactorValueError(false);
      } else if (isNaN(value)) {
        setEmissionFactorValueErrorMessage(decimalsNotAllowedError);
        setIsEmissionFactorValueError(true);
      } else if (value < 0 || value === "-") {
        setEmissionFactorValueErrorMessage(negativeNotallowed);
        setIsEmissionFactorValueError(true);
      } else if (value > 99999999999) {
        setEmissionFactorValueErrorMessage(maxlimitExceeded);
        setIsEmissionFactorValueError(true);
      } else if (!decimalNumberRegExp.test(value)) {
        setEmissionFactorValueErrorMessage(only2DecimalsAllowed);
        setIsEmissionFactorValueError(true);
      } else {
        setEmissionFactorValueErrorMessage("");
        setIsEmissionFactorValueError(false);
      }
    } else {
      // Relative and Extend
      if (value === "") {
        setEmissionFactorValueErrorMessage("");
        setIsEmissionFactorValueError(false);
      } else if (isNaN(value)) {
        setEmissionFactorValueErrorMessage(decimalsNotAllowedError);
        setIsEmissionFactorValueError(true);
      } else if (unitSelected === "Relative" && replaceChange === "Extend") {
        if (value < 0 || value > 99999999999) {
          setEmissionFactorValueErrorMessage(relativeExtendEmitionFactorError);
          setIsEmissionFactorValueError(true);
        } else {
          setEmissionFactorValueErrorMessage("");
          setIsEmissionFactorValueError(false);
        }
      } else if (value < -100 || value > 9999.99) {
        setEmissionFactorValueErrorMessage(relativePercentageError);
        setIsEmissionFactorValueError(true);
      } else {
        setEmissionFactorValueErrorMessage("");
        setIsEmissionFactorValueError(false);
      }
    }
  };

  // Onchange of Input fields
  const handleOnChange = (value, fieldName) => {
    dispatch(setWafErrorFlag(false));
    if (fieldName === "dataType") {
      setDataType(value);
      dispatch(setSelectedDataType({ dataType: value }));
      setValue("");
    } else if (fieldName === "cumulative") {
      setCumulative(value);
      setValue("");
    } else if (fieldName === "unit") {
      setUnit(value);
      setActivityDataUnit("");
      setActivityDataValue("");
      setValue("");     
      setEmissionFactorUnit("");
    } else if (fieldName === "value") {
      checkValueValidation(value);
      setValue(value);
    } else if (fieldName === "startYear") {
      checkStartYearValidation(value);
      setStartYear(value);
    } else if (fieldName === "endYear") {
      checkEndYearValidation(value);
      setEndYear(value);
    } else if (fieldName === "ruleName") {
      let error = "";
      let flag = false;
      if (value?.length >= maxLength100) {
        error = ruleNameLength;
        setRuleNameErrorMessage(error);
        setRuleNameError(true);
        lastCheckedRuleName.current = '';
        return;
      } else {
        setRuleNameErrorMessage("");
        setRuleNameError(false);
      }
      setRuleName(value);
      latestRuleNameRef.current = value;
      setIsChange(true);
      if (
        ruleNameRegexp.test(value) &&
        value !== "-"
      ) {
        if (value === "") {
          error = ruleNameRequiredError;
          flag = true;
        }
        setRuleNameErrorMessage(error);
        setRuleNameError(flag);
      } else {
        setRuleNameErrorMessage(commonError);
        setRuleNameError(true);
      }
    } else if (fieldName === "activityDataValue") {
      checkActivityDataValue(value);
      setActivityDataValue(value);
    } else if (fieldName === "emissionFactorValue") {
      checkEmissionFactorValue(value);
      setEmissionFactorValue(value);
    } else if (fieldName === "activityDataUnit") {
      if (value.length !== 0) {
        const selectedValue = value?.[value.length - 1];
        const unitLabel = selectedValue?.label || "";
        
        // Clear any previous errors since validation passed in onChange
        setActivityDataUnitErrorMessage("");
        setIsActivityDataUnitError(false);
        
        // Set value (validation already done in onChange handler)
        setActivityDataUnit(selectedValue);
        setEmissionFactorUnit("kgCO2e/" + unitLabel);
      } else {
        setActivityDataUnit("");
        setEmissionFactorUnit("");
        setActivityDataUnitErrorMessage("");
        setIsActivityDataUnitError(false);
      }
    } else if (fieldName === "targetHierarchy") {
      setTrgtHrchy(value);
    } else if (fieldName === "transferOrCopy") {
      setTransferCopy(value);
    } else if (fieldName === "ruleDescription") {
      setRuleDesc(value);
      let error = "";
      if (value?.length > 2000) {
        error = ruleDescLength;
        setRuleDescErrorMessage(error);
      } else if (value && !ruleDescRegexp.test(value)) {
        setRuleDescErrorMessage(commonError);
      } else if (value === "-") {
        setRuleDescErrorMessage(commonError);
      } else {
        setRuleDescErrorMessage("");
      }
    } else if (fieldName === "source") {
      setSource(value);
      let error = "";
      if (value?.length > 200) {
        error = ruleSourceLength;
        setRuleSourceErrorMessage(error);
      } else if (value && !ruleSourceRegexp.test(value)) {
        setRuleSourceErrorMessage(commonError);
      } else if (value === "-") {
        setRuleSourceErrorMessage(commonError);
      } else {
        setRuleSourceErrorMessage("");
      }
    } else if (fieldName === "editType") {
      setEditType(value);
      if (value === "Manual edit") {
        dispatch(setIsManualEdit({ isManualEdit: true }));
      } else {
        dispatch(setIsManualEdit({ isManualEdit: false }));
      }
    } else if (fieldName === "replaceChangeType") {
      setReplaceChangeType(value);
      if (value === "Extend") {
        dispatch(setTogglechecked({ isExtend: true }));
        setSimulateBtnDisable(true);
      } else {
        dispatch(setTogglechecked({ isExtend: false }));
      }
    }
  };

  /**
   * Validates activity data unit input
   * @param {string} label - The unit label to validate
   * @returns {Object} - { isValid: boolean, errorMessage: string }
   */
  const validateActivityDataUnit = (label) => {
    if (!label) return { isValid: true, errorMessage: "" };
    
    if (label.length > 200) {
      return { isValid: false, errorMessage: dataUnitLength };
    }
    
    if (!financialParamDataUnitRegExp.test(label)) {
      return { isValid: false, errorMessage: adDataUnitError };
    }
    
    return { isValid: true, errorMessage: "" };
  };

  /**
   * Handles activity data unit change with simple validation
   * If value is invalid, clear it and show error message
   */
  const handleActivityDataUnitChange = (value) => {
    // Handle empty/cleared field
    if (!value || value.length === 0) {
      setActivityDataUnitErrorMessage("");
      setIsActivityDataUnitError(false);
      handleOnChange(value, "activityDataUnit");
      return;
    }
    
    // Get the newly created/selected value
    const newValue = value[value.length - 1];
    const label = newValue?.label || "";
    
    // Validate the new value
    const validation = validateActivityDataUnit(label);
    
    if (!validation.isValid) {
      // Invalid: Clear the field first, then show error message
      // Note: handleOnChange clears error state, so we need to set it again after
      handleOnChange([], "activityDataUnit");
      
      // Set error message after clearing the field to ensure it persists
      setActivityDataUnitErrorMessage(validation.errorMessage);
      setIsActivityDataUnitError(true);
      return;
    }
    
    // Valid: Clear any previous errors and update state
    setActivityDataUnitErrorMessage("");
    setIsActivityDataUnitError(false);
    handleOnChange(value, "activityDataUnit");
  };

  const checkSimulateEnableValidation = () => {
    // If any of these conditions fail, button must be disabled
    if (!hasAppliedDataSelection) {
      setSimulateBtnDisable(true);
      return;
    }
    if (hasBlockingUnitValidationError) {
      setSimulateBtnDisable(true);
      return;
    }
    if (wafErrorFlag) {
      setSimulateBtnDisable(true);
      return;
    }
    // Rule metadata errors apply to all modes
    const hasRuleMetaErrors = ruleNameError || !!ruleDescErrorMessage || !!ruleSourceErrorMessage;

    // Manual Edit Mode Validation
    if (editType === "Manual edit") {
      const isValid = dataType && rule && manualEditRules.length > 0 && !hasRuleMetaErrors;
      setSimulateBtnDisable(!isValid);
      return;
    }
    // Batch Edit Mode Validation
    if (editType === "Batch edit") {
      // Base required fields for batch edit
      const hasValidBatchEditBaseFields =
        dataType &&
        cumlative &&
        unitSelected &&
        value &&
        startYear &&
        endYear &&
        rule &&
        !hasRuleMetaErrors &&
        !valueError &&
        !showstartYearError &&
        !showendYearError;

      // Extend Mode Validation
      if (replaceChange === "Extend") {
        const hasValidExtendRequiredFields =
          dataType &&
          rule &&
          trgtHrchy &&
          trnsfrOrCopy &&
          activityDataUnit &&
          activityDataValue &&
          emissionFactorUnit &&
          emissionFactorValue &&
          !isActivityDataValueError &&
          !isEmissionFactorValueError &&
          !isActivityDataUnitError &&
          unitSelected &&
          cumlative &&
          startYear &&
          endYear &&
          !hasRuleMetaErrors &&
          !showstartYearError &&
          !showendYearError &&
          newExtendhierarchy.saved &&
          selectedExtendHierarchy === trgtHrchy;

        setSimulateBtnDisable(!hasValidExtendRequiredFields);
        return;
      }

      // Edit Mode (Replace) Validation
      if (!hasValidBatchEditBaseFields) {
        setSimulateBtnDisable(true);
        return;
      }

      // Additional validation for project types 1 and 2 with Absolute units
      if (project.projectType === 1 || project.projectType === 2) {
        if (unitSelected === "Absolute" && dataType === addForecastSpecificationDataTypeOptions[0]) {
          // Activity Data validation
          const hasADError = validationFlag.isDuplicate_AD === "Y";
          setSimulateBtnDisable(hasADError);
          return;
        } else if (unitSelected === "Absolute" && dataType === addForecastSpecificationDataTypeOptions[1]) {
          // Emission Factor validation
          const hasEFError = hasEFValidationError();
          setSimulateBtnDisable(hasEFError);
          return;
        }
      }
      // All validations passed for batch edit
      setSimulateBtnDisable(false);
      return;
    }
    // Default: disable if no valid edit type
    setSimulateBtnDisable(true);
  };

  const openFiltersModal = () => {
    setIsFilterOpen(true);
    // resetSimulatefields();
  };

  //Closing the data selection
  const onfilterClose = () => {
    setIsFilterOpen(false);
  };

  //getSelectedColumns from Data Selection

  const getselectedCols = (field) => {
    let array = [];
    if (field === "Emission") {
      array.push("scope");
      newExtendhierarchy.category1.value && array.push("category_level1");
      newExtendhierarchy.category2.value && array.push("category_level2");
      newExtendhierarchy.category3.value && array.push("category_level3");
    } else if (field === "Geography") {
      newExtendhierarchy.region1.value && array.push("region_level1");
      newExtendhierarchy.region2.value && array.push("region_level2");
      newExtendhierarchy.region3.value && array.push("region_level3");
    } else if (field === "Organisational") {
      newExtendhierarchy.entity1.value && array.push("entity_level1");
      newExtendhierarchy.entity2.value && array.push("entity_level2");
      newExtendhierarchy.entity3.value && array.push("entity_level3");
      newExtendhierarchy.entity4.value && array.push("entity_level4");
    } else if (field === "Custom") {
      newExtendhierarchy.custom1.value && array.push("custom_specification1");
      newExtendhierarchy.custom2.value && array.push("custom_specification2");
      newExtendhierarchy.custom3.value && array.push("custom_specification3");
    }
    return array;
  };

  //getting unselectedCols
  const getUnselectedCols = (field) => {
    let array = [];
    if (field === "Emission") {
      newExtendhierarchy.category2.value === undefined &&
        array.push("category_level2");
      newExtendhierarchy.category3.value === undefined &&
        array.push("category_level3");
    } else if (field === "Geography") {
      newExtendhierarchy.region2.value === undefined &&
        array.push("region_level2");
      newExtendhierarchy.region3.value === undefined &&
        array.push("region_level3");
    } else if (field === "Organisational") {
      newExtendhierarchy.entity2.value === undefined &&
        array.push("entity_level2");
      newExtendhierarchy.entity3.value === undefined &&
        array.push("entity_level3");
      newExtendhierarchy.entity4.value === undefined &&
        array.push("entity_level4");
    }
    return array;
  };

  //getting New Hierarchy values
  const getNewHierarchy = (field) => {
    let string = "";
    if (field === "Emission") {
      string = newExtendhierarchy.scope.value;
      if (newExtendhierarchy.category1.value) {
        string = string + "," + newExtendhierarchy.category1.value;
      }
      if (newExtendhierarchy.category2.value) {
        string = string + "," + newExtendhierarchy.category2.value;
      }
      if (newExtendhierarchy.category3.value) {
        string = string + "," + newExtendhierarchy.category3.value;
      }
    } else if (field === "Geography") {
      string = newExtendhierarchy.region1.value;
      if (newExtendhierarchy.region2.value) {
        string = string + "," + newExtendhierarchy.region2.value;
      }
      if (newExtendhierarchy.region3.value) {
        string = string + "," + newExtendhierarchy.region3.value;
      }
    } else if (field === "Organisational") {
      string = newExtendhierarchy.entity1.value;
      if (newExtendhierarchy.entity2.value) {
        string = string + "," + newExtendhierarchy.entity2.value;
      }
      if (newExtendhierarchy.entity3.value) {
        string = string + "," + newExtendhierarchy.entity3.value;
      }
      if (newExtendhierarchy.entity4.value) {
        string = string + "," + newExtendhierarchy.entity4.value;
      }
    } else if (field === "Custom") {
      if (newExtendhierarchy.custom1.value) {
        string = string + newExtendhierarchy.custom1.value;
      }
      if (newExtendhierarchy.custom2.value) {
        if (string) {
          string = string + "," + newExtendhierarchy.custom2.value;
        } else {
          string = string + newExtendhierarchy.custom2.value;
        }
      }
      if (newExtendhierarchy.custom3.value) {
        if (string) {
          string = string + "," + newExtendhierarchy.custom3.value;
        } else {
          string = string + newExtendhierarchy.custom3.value;
        }
      }
    }
    return string;
  };

  // Memoized payload for simulate and save operations
  const simulateSavePayload = useMemo(() => ({
    engagementCode: engagement.engagementCode,
    engagementId: engagement.id,
    name: rule,
    Ruledescription: ruleDesc,
    Source: source?.replace(/(http\S+)/g, "'$1'"),
    calculation_type: unitSelected,
    cumulative_flag: cumlative,
    abatement_value: parseFloat(value),
    data_type: dataType,
    start_year: parseInt(startYear),
    end_year: parseInt(endYear),
    createdby: user.username,
    modifiedby: user.username,
    dropDownMetaData: metaData,
    datatype_unit: "kWh",
    project_type:
      project.projectType === 1
        ? "Reduce"
        : project.projectType === 2
          ? "Replace"
          : "Compensate",
    project_id: project.projectId,
  }), [engagement.engagementCode, engagement.id, rule, ruleDesc, source, unitSelected, cumlative, value, dataType, startYear, endYear, user.username, metaData, project.projectType, project.projectId]);

  //Simulate function
 const onSimulate = async () => {
    dispatch(setWafErrorFlag(false));
    dispatch(setGraphSimulateFlag({ isGraphSimulate: false }));
    setSimulateloader(true);
    dispatch(setM3Step2Loader({ step2GraphTableLoader: true }));
    if (editType === "Manual edit") {
      onManualEdit("Simulate");
    } else {
      if (project.projectType === 2) {
        if (replaceChange === "Extend") {
          createExtendRule("Simulate");
        } else {
          let simulateSaveReplacePayload = {
            ...simulateSavePayload,
            target_Name: "",
            view_type: "Simulate",
            ruleType: "Simulate",
            changeType: "Edit",
            activitydata_value: "",
            activitydata_Unit: "",
            emissiondata_value: "",
            emissiondata_unit: "",
            targetHierarchy: "",
            transferAD: "N",
            columnNames: filtersPayload.columnNames,
            selectedcolumns: [],
            nonselectedcolumns: [],
          };
          const data = await SaveM3Step2ReplaceData({
            simulateSaveReplacePayload,
          });
          dispatch(
            setSimulateDataOnTable({ simulateTableData: data?.data?.tableData })
          );
          dispatch(setGraphSimulateFlag({ isGraphSimulate: true }));
          dispatch(
            setSimulateDataOnGraph({ simulateGraphData: data?.data?.graphData })
          );
        }
      } else {
        let request = filtersPayload;
        const simulatePayload = { ...simulateSavePayload, view_type: "Simulate", columnNames: request.columnNames };
        const data = await getM3TableGraphData({ simulateSavePayload: simulatePayload });
        dispatch(setSimulateDataOnTable({ simulateTableData: data?.data?.tableData }));
        dispatch(setGraphSimulateFlag({ isGraphSimulate: true }));
        dispatch(setSimulateDataOnGraph({ simulateGraphData: data?.data?.graphData }));
        if(data?.statusCode === 400) {
          setRuleNameError(true);
          setRuleNameErrorMessage(ruleNameUniqueMsg);
        }
      }
      dispatch(setSimulateFlag({ isSimulate: true }));
      setSimulateloader(false);
      dispatch(setM3Step2Loader({ step2GraphTableLoader: false }));
    }
    
  };

  //Save function
  const onSave = async () => {
    if (hasBlockingUnitValidationError) {
      return;
    }

    dispatch(setWafErrorFlag(false));
    try {
      setSaveLoader(true);
      dispatch(setGraphSimulateFlag({ isGraphSimulate: false }));
      dispatch(setM3Step2Loader({ step2GraphTableLoader: true }));
      dispatch(setSimulateFlag({ isSimulate: false }));
      setSimulateloader(false);
      lastCheckedRuleName.current = '';
      if (editType === "Manual edit") {
        onManualEdit("Save");
      } else {
        if (project.projectType === 2) {
          if (replaceChange === "Extend") {
            createExtendRule("Save");
          } else {
            let simulateSaveReplacePayload = {
              ...simulateSavePayload,
              target_Name: "",
              view_type: "M3-ApplyFilter",
              changeType: "Edit",
              ruleType: "Save",
              activitydata_value: "",
              activitydata_Unit: "",
              emissiondata_value: "",
              emissiondata_unit: "",
              targetHierarchy: "",
              transferAD: "N",
              columnNames: filtersPayload.columnNames,
              selectedcolumns: [],
              nonselectedcolumns: [],
            };
            const data = await SaveM3Step2ReplaceData({
              simulateSaveReplacePayload,
            });
            dispatch(setReduceDefautViewData({ defaultViewData: data?.data }));
            if(data?.statusCode === 400) {
              setRuleNameError(true);
              setRuleNameErrorMessage(ruleNameUniqueMsg);
            } else {
              setRuleName("");
              setRuleNameError(false);
              setRuleNameErrorMessage("");
              resetSimulatefields();
              dispatch(setHasDataSelectionApplied({ hasApplied: false }));
            }
            setSaveLoader(false);
            dispatch(setM3Step2Loader({ step2GraphTableLoader: false }));
            setSimulateloader(false);
            setSimulateBtnDisable(true);
            dispatch(setselectedUIAllFilters({selectedUIAllFilters: {}}));
          }
        } else {
          let request = filtersPayload;
          const savePayload = { ...simulateSavePayload, view_type: "M3-ApplyFilter", columnNames: request.columnNames };
          const data = await getM3TableGraphData({ simulateSavePayload: savePayload });
          dispatch(setReduceDefautViewData({ defaultViewData: data?.data }));
          if(data?.statusCode === 400) {
            setRuleNameError(true);
            setRuleNameErrorMessage(ruleNameUniqueMsg);
          } else {
            setRuleName("");
            setRuleNameError(false);
            setRuleNameErrorMessage("");
            resetSimulatefields();
            dispatch(setHasDataSelectionApplied({ hasApplied: false }));
          }
          setSaveLoader(false);
          dispatch(setM3Step2Loader({ step2GraphTableLoader: false }));
          setSimulateloader(false);
          setSimulateBtnDisable(true);
        }
      }
    } catch (error) {
      setSaveLoader(false);
      dispatch(setM3Step2Loader({ step2GraphTableLoader: false }));
      setSimulateloader(false);
      setSimulateBtnDisable(true);  
      lastCheckedRuleName.current = '';      
    }
    dispatch(setselectedUIAllFilters({selectedUIAllFilters: {}}));
    
  };

  const onManualEdit = async (type) => {
    let unique = [...new Set(manualEditRules.map((x) => x.rowIndex))];
    let payload = [];
    unique.forEach((row) => {
      let unique_rules = [...new Set(manualEditRules.map((x) => x.start_year))];
      let array = [];
      let payloadObject = {
        engagementCode: engagement.engagementCode,
        engagementId: engagement.id,
        createdby: user.username.toString(),
        modifiedby: user.username.toString(),
        project_type:
          project.projectType === 1
            ? "Reduce"
            : project.projectType === 2
              ? "Replace"
              : "Compensate",
        project_id: project.projectId,
        view_type: type === "Simulate" ? type : "M3-ApplyFilter",
        data_type: dataType,
        calculation_type:
          dataType === addForecastSpecificationDataTypeOptions[1] ? "Absolute" : "Relative",
        cumulative_flag: "N",
        name: rule,
        rule_type: type,
        ruledescription: ruleDesc,
        source: source?.replace(/(http\S+)/g, "'$1'"),
        manualEditYearValue: array,
        abatement_value: 0.0,
        columnNames: filtersPayload.columnNames,
        dropDownMetaData: dropdownMetadataFinal,
      };
      unique_rules.forEach((year) => {
        let x = false;
        for (let i = manualEditRules.length - 1; i >= 0; i--) {
          if (
            manualEditRules[i]["start_year"] === year &&
            row === manualEditRules[i]["rowIndex"] &&
            !x
          ) {
            array.push({
              start_year: parseInt(year),
              end_year: parseInt(year),
              abatement_value: parseFloat(
                manualEditRules[i]["abatement_value"]
              ),
            });
            x = true;
            payloadObject.datatype_unit = manualEditRules[i]["data"]["unit"];
            payloadObject.dropDownMetaData = [
              {
                columnType: "Scope",
                columnValue: manualEditRules[i]["data"]["scope"],
              },
              {
                columnType: "Category_level1",
                columnValue:
                  manualEditRules[i]["data"]["category_level1"] === ""
                    ? "All"
                    : manualEditRules[i]["data"]["category_level1"],
              },
              {
                columnType: "Category_level2",
                columnValue:
                  manualEditRules[i]["data"]["category_level2"] === ""
                    ? "All"
                    : manualEditRules[i]["data"]["category_level2"],
              },
              {
                columnType: "Category_level3",
                columnValue:
                  manualEditRules[i]["data"]["category_level3"] === ""
                    ? "All"
                    : manualEditRules[i]["data"]["category_level3"],
              },
              {
                columnType: "Region_level1",
                columnValue:
                  manualEditRules[i]["data"]["region_level1"] === ""
                    ? "All"
                    : manualEditRules[i]["data"]["region_level1"],
              },
              {
                columnType: "Region_level2",
                columnValue:
                  manualEditRules[i]["data"]["region_level2"] === ""
                    ? "All"
                    : manualEditRules[i]["data"]["region_level2"],
              },
              {
                columnType: "Region_level3",
                columnValue:
                  manualEditRules[i]["data"]["region_level3"] === ""
                    ? "All"
                    : manualEditRules[i]["data"]["region_level3"],
              },
              {
                columnType: "Entity_level1",
                columnValue:
                  manualEditRules[i]["data"]["entity_level1"] === ""
                    ? "All"
                    : manualEditRules[i]["data"]["entity_level1"],
              },
              {
                columnType: "Entity_level2",
                columnValue:
                  manualEditRules[i]["data"]["entity_level2"] === ""
                    ? "All"
                    : manualEditRules[i]["data"]["entity_level2"],
              },
              {
                columnType: "Entity_level3",
                columnValue:
                  manualEditRules[i]["data"]["entity_level3"] === ""
                    ? "All"
                    : manualEditRules[i]["data"]["entity_level3"],
              },
              {
                columnType: "Entity_level4",
                columnValue:
                  manualEditRules[i]["data"]["entity_level4"] === ""
                    ? "All"
                    : manualEditRules[i]["data"]["entity_level4"],
              },
              {
                columnType: "Custom_specification1",
                columnValue:
                  manualEditRules[i]["data"]["custom_request1"] === ""
                    ? "All"
                    : manualEditRules[i]["data"]["custom_request1"],
              },
              {
                columnType: "Custom_specification2",
                columnValue:
                  manualEditRules[i]["data"]["custom_request2"] === ""
                    ? "All"
                    : manualEditRules[i]["data"]["custom_request2"],
              },
              {
                columnType: "Custom_specification3",
                columnValue:
                  manualEditRules[i]["data"]["custom_request3"] === ""
                    ? "All"
                    : manualEditRules[i]["data"]["custom_request3"],
              },
            ];
            // payloadObject.dropDownMetaData = [...dropdownMetadataFinal];
          }
        }
      });
      payload.push(payloadObject);
    });
    const data = await manualEditM3Step2({ payload });
    if (type === "Simulate") {
      dispatch(setSimulateFlag({ isSimulate: true }));
      dispatch(setSimulateDataOnTable({ simulateTableData: data?.data?.tableData }));
      dispatch(setGraphSimulateFlag({ isGraphSimulate: true }));
      dispatch(setSimulateDataOnGraph({ simulateGraphData: data?.data?.graphData }));
      if(data?.statusCode === 400) {
        setRuleNameError(true);
        setRuleNameErrorMessage(ruleNameUniqueMsg);
      }
      setSimulateloader(false);
      // setSimulateBtnDisable(true);
      dispatch(setM3Step2Loader({ step2GraphTableLoader: false }));
    } else {
      setRuleName("");
      setEditType("Batch edit");
      dispatch(setIsManualEdit({ isManualEdit: false }));
      dispatch(setSimulateFlag({ isSimulate: false }));
      dispatch(setGraphSimulateFlag({ isGraphSimulate: false }));
      dispatch(setReduceDefautViewData({ defaultViewData: data }));
      setSimulateBtnDisable(true);
      dispatch(resetManualEditRules({ array: [] }));
      dispatch(setM3Step2Loader({ step2GraphTableLoader: false }));
      setSaveLoader(false);
    }
  };

  const createExtendRule = async (type) => {
    try {
      let selectedCols = getselectedCols(trgtHrchy);
      let unSelectedCols = getUnselectedCols(trgtHrchy);
      let newhierarchy = getNewHierarchy(trgtHrchy);
      let simulateSaveReplacePayload = {
        ...simulateSavePayload,
        target_Name: newhierarchy,
        view_type: "M3-ApplyFilter",
        ruleType: type === "Simulate" ? "Simulate" : "Save",
        changeType: "Extend",
        cumulative_flag: cumlative,
        activitydata_value: activityDataValue,
        activitydata_Unit: activityDataUnit ? activityDataUnit.label : "",
        emissiondata_value: emissionFactorValue,
        emissiondata_unit: emissionFactorUnit,
        targetHierarchy: trgtHrchy,
        transferAD: trnsfrOrCopy,
        columnNames: filtersPayload.columnNames,
        selectedcolumns: selectedCols,
        nonselectedcolumns: unSelectedCols,
        abatement_value: 0,
      };
      const data = await SaveM3Step2ReplaceData({
        simulateSaveReplacePayload,
      });
      let request = {
        engagementCode: engagement.engagementCode,
        projectID: project.projectId,
      };
      const response = await getReplaceHierarchyData({ request });
      dispatch(setHierarchialData({ hierarchialData: response }));
      if (type === "Simulate") {
        dispatch(setSimulateDataOnTable({ simulateTableData: data?.data?.tableData }));
        dispatch(setGraphSimulateFlag({ isGraphSimulate: true }));
        dispatch(setSimulateDataOnGraph({ simulateGraphData: data?.data?.graphData }));
        setSimulateloader(false);
      } else {
        dispatch(setReduceDefautViewData({ defaultViewData: data?.data }));
        setSaveLoader(false);
        dispatch(setExtendNewHierarchy({ rule: {} }));
        dispatch(setselectedUIAllFilters({selectedUIAllFilters: {}}));
      }
      if(data?.statusCode === 400) {
        setRuleNameError(true);
        setRuleNameErrorMessage(ruleNameUniqueMsg);
      } else {
        setRuleName("");
        setRuleNameError(false);
        setRuleNameErrorMessage("");
        if (type === "Save") {
          resetSimulatefields();
          dispatch(setHasDataSelectionApplied({ hasApplied: false }));
        }
      }
      dispatch(setM3Step2Loader({ step2GraphTableLoader: false }));
      setIsExtendedRuleCreated(true);
    } catch (error) {
      // Ensuring loaders are reset if API call fails
      if (type === "Simulate") {
        setSimulateloader(false);
      } else {
        setSaveLoader(false);
      }
      dispatch(setM3Step2Loader({ step2GraphTableLoader: false }));
      console.error("Error in createExtendRule:", error);
    }
  };

  const onExtendClose = (data) => {
    setExtendModalOpen(false);
  };
  const openExtendModal = () => {
    setExtendModalOpen(true);
    if(selectedExtendHierarchy !== trgtHrchy)
      dispatch(setExtendNewHierarchy({ rule: {} }));
  };

  const resetSimulatefields = () => {
    setCumulative("");
    // Don't reset unit selection - it's needed for validation warnings
    // setUnit("");
    setValue("");
    setStartYear("");
    setEndYear("");
    setSimulateBtnDisable(true);
    setTrgtHrchy("");
    setTransferCopy("");
    setActivityDataUnit("");
    setActivityDataValue("");
    setEmissionFactorUnit("");
    setEmissionFactorValue("");
    setRuleDesc("");
    setSource("");
    setActivityDataUnitErrorMessage("");
    setIsActivityDataUnitError(false);
  };

  const handlecheckIfRuleNameExist = async (event) => {
    if (rule === "") return;
    setIsChange(true);
    const requestedRuleName = rule?.trim();
    if(ruleNameRegexp.test(rule) && rule) {
      if (!requestedRuleName) {
        setRuleNameError(true);
        setRuleNameErrorMessage(ruleNameRequiredError);
        setIsChange(true);
        return;
      }
      if (!rule || lastCheckedRuleName.current === requestedRuleName) return;

      lastCheckedRuleName.current = requestedRuleName;

      const data = await getUniqueProjectRuleFlag({
        request: {
          projectRulename: encodeURIComponent(requestedRuleName),
          projectId: project?.projectId,
          engagementId: engagement?.id,
        },
      });

      if (requestedRuleName !== latestRuleNameRef.current?.trim()) {
        return;
      }

      if (data?.uniqueflag === false) {
        setRuleNameError(true);
        setRuleNameErrorMessage(ruleNameUniqueMsg);
        setIsChange(true);
      } else {
        setRuleNameError(false);
        setRuleNameErrorMessage("");
        setIsChange(false);
      }

      return data?.uniqueflag;
    }
  };

  return (
    <div className="emissions-simulate-section">
      <div className="emissions-simulate-content">
        <div className="emissions-simultae-content-row">
          <div className="emissions-simulate-content-row-dropdown">
            <span>
              {ruleName}
              <span className="required-star">*</span>
              <Tooltip
                trigger={<EmissionIcon />}
                variant="ghost"
                tooltipText={ruleNameTooltip}
              ></Tooltip>
            </span>
            <Input
              type="text"
              errorMessage={ruleNameErrorMessage}
              isError={ruleNameError}
              onChange={(event) => {
                handleOnChange(event?.target?.value, "ruleName");
              }}
              onBlur={handlecheckIfRuleNameExist}
              value={rule}
              disabled={
                lockedData === 1 &&
                lockedBy !== user?.username &&
                project.projectId
              }
              maxLength={110}
            ></Input>
          </div>
        </div>
        <div className="emissions-simultae-content-row">
          <div className="emissions-simulate-content-row-dropdown">
            <span>
              {ruleDescription}
              <Tooltip
                trigger={<EmissionIcon />}
                variant="ghost"
                tooltipText={ruleDescTooltip}
              ></Tooltip>
            </span>
            <TextArea
              type="text"
              onChange={(event) => {
                handleOnChange(event?.target?.value, "ruleDescription");
              }}
              errorMessage={ruleDescErrorMessage}
              isError={!!ruleDescErrorMessage}
              value={ruleDesc}
              disabled={
                lockedData === 1 &&
                lockedBy !== user?.username &&
                project?.projectId
              }
              maxLength={5000}
            ></TextArea>
          </div>
        </div>
        <div className="emissions-simultae-content-row">
          <div className="emissions-simulate-content-row-dropdown">
            <span>
              {addGMPSource}
              <Tooltip
                trigger={<EmissionIcon />}
                variant="ghost"
                tooltipText={sourceRuleTooltip}
              ></Tooltip>
            </span>
            <Input
              type="text"
              onChange={(event) => {
                handleOnChange(event?.target?.value, "source");
              }}
              value={source}
              disabled={
                lockedData === 1 &&
                lockedBy !== user?.username &&
                project?.projectId
              }
              errorMessage={ruleSourceErrorMessage}
              isError={!!ruleSourceErrorMessage}
              maxLength={500}
            ></Input>
          </div>
        </div>
        {project.projectType === 2 && (
          <div className="emissions-simultae-content-row">
            <div className="emissions-simulate-content-row-dropdown">
              <span>
                {projectDetailsBusinessRulesChangeType}
                <span className="required-star">*</span>
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={changeTypeTooltip}
                ></Tooltip>
              </span>
              <Select
                options={editExtend}
                onChange={(event) => {
                  handleOnChange(event, "replaceChangeType");
                }}
                value={replaceChange}
                disabled={
                  (lockedData === 1 &&
                    lockedBy !== user?.username &&
                    project?.projectId) ||
                  editType === "Manual edit"
                }
              ></Select>
            </div>
          </div>
        )}
        <div className="emissions-simultae-content-row">
          <div className="emissions-simulate-content-row-dropdown">
            <span>
              {edittype}
              <span className="required-star">*</span>
              <Tooltip
                trigger={<EmissionIcon />}
                variant="ghost"
                tooltipText={editTypeTooltip}
              ></Tooltip>
            </span>
            <Select
              options={editTypeOptions}
              onChange={(event) => {
                handleOnChange(event, "editType");
              }}
              value={editType}
              disabled={replaceChange === "Extend"}
            ></Select>
          </div>
        </div>
        <div className="emissions-simultae-content-row">
          <div className="emissions-simulate-content-row-dropdown">
            <Button variant="primary-alt" onClick={() => openFiltersModal()}>
              <AreaSeacrhIcon />
              {DataSelection} <span className="required-star">*</span>
            </Button>
          </div>
        </div>
        {showUnitValidationError && project?.projectType !== 3 && (
          <div className="emissions-simultae-content-row">
            <div className="emissions-simulate-content-row-dropdown">
              <span className="emissions-simulate-unit-validation-error">
                {dataType == addForecastSpecificationDataTypeOptions[0]
                  ? aDValidationError
                  : eFValidationError}
              </span>
            </div>
          </div>
        )}
        {replaceChange === "Extend" && (
          <div className="emissions-simultae-content-row">
            <div className="emissions-simulate-content-row-dropdown">
              <span>
                {targetHierarchy}
                <span className="required-star">*</span>
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={targetHierarchyTooltip}
                ></Tooltip>
              </span>
              <Select
                options={targetHierarchyValues}
                onChange={(value) => {
                  handleOnChange(value, "targetHierarchy");
                }}
                value={trgtHrchy}
                disabled={shouldDisableExtendField()}
              />
            </div>
          </div>
        )}
        {replaceChange === "Extend" && (
          <div className="emissions-simultae-content-row">
            <div className="emissions-simulate-content-row-dropdown">
              <Button
                variant="primary-alt"
                onClick={() => openExtendModal()}
                disabled={shouldDisableDefineHierarchyButton()}
              >
                {defineNewHrchy}
              </Button>
            </div>
          </div>
        )}
        {replaceChange === "Edit" && (
          <div className="emissions-simultae-content-row">
            <div className="emissions-simulate-content-row-dropdown">
              <span>
                {addForecastSpecificationDataType}{" "}
                <span className="required-star">*</span>
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={forecastDataTypeTooltip}
                ></Tooltip>
              </span>
              <Select
                options={
                  project.projectType === 3
                    ? emissionArray
                    : addForecastSpecificationDataTypeOptions
                }
                value={dataType}
                onChange={(event) => {
                  handleOnChange(event, "dataType");
                }}
                disabled={
                  lockedData === 1 &&
                  lockedBy !== user?.username &&
                  project?.projectId
                }
              ></Select>
            </div>
          </div>
        )}
        {editType === "Batch edit" && (
          <div className="emissions-simultae-content-row">
            <div className="emissions-simulate-content-row-dropdown">
              <span>
                {absoluteorRelative}
                <span className="required-star">*</span>
                <span className="tooltip">
                  <Tooltip
                    trigger={<EmissionIcon />}
                    variant="ghost"
                    tooltipText={unitTooltip}
                  ></Tooltip>
                </span>
              </span>
              {shouldShowAbsoluteEFInfo && (
                <i className="motif-overline-default-light" style={{...INFO_MESSAGE_STYLE, visibility: 'hidden'}}>
                  {EMISSION_CUMULATIVE_ABSOLUTE_EF_INFO}
                </i>
              )}
              <Select
                options={unitDropdown}
                value={unitSelected}
                onChange={(event) => {
                  handleOnChange(event, "unit");
                }}
                disabled={
                  lockedData === 1 &&
                  lockedBy !== user?.username &&
                  project?.projectId
                }
              ></Select>
            </div>
            <div className="emissions-simulate-content-row-dropdown">
              <span>
                {cumulative}
                <span className="required-star">*</span>
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={cumulativeTooltip}
                ></Tooltip>
              </span>
              {shouldShowAbsoluteEFInfo && (
                <i className="motif-overline-default-light" style={INFO_MESSAGE_STYLE}>
                  {EMISSION_CUMULATIVE_ABSOLUTE_EF_INFO}
                </i>
              )}
              <Select
                options={cumulativedropdown}
                value={cumlative}
                onChange={(event) => {
                  handleOnChange(event, "cumulative");
                }}
                disabled={
                  lockedData === 1 &&
                  lockedBy !== user?.username &&
                  project?.projectId
                }
              ></Select>
            </div>
          </div>
        )}
        {replaceChange === "Extend" && (
          <div className="emissions-simultae-content-row">
            <div className="emissions-simulate-content-row-dropdown">
              <span>
                {transferOrCopy}
                <span className="required-star">*</span>
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={transferADTooltip}
                ></Tooltip>
              </span>
              <Select
                options={transferCopyOptions}
                onChange={(event) => {
                  handleOnChange(event, "transferOrCopy");
                }}
                value={trnsfrOrCopy}
                disabled={shouldDisableExtendField()}
              ></Select>
            </div>
          </div>
        )}
        {editType === "Batch edit" && (
          <div className="emissions-simultae-content-row">
            <div className="emissions-simulate-content-row-dropdown">
              <span>
                {strtYr}
                <span className="required-star">*</span>
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={emissionsStartyearTooltip}
                ></Tooltip>
              </span>
              <Input
                errorMessage={startYearErrorMessage}
                isError={showstartYearError}
                disableErrorPlaceholder={true}
                onChange={(event) => {
                  handleOnChange(event?.target?.value, "startYear");
                }}
                value={startYear}
                disabled={
                  lockedData === 1 &&
                  lockedBy !== user?.username &&
                  project?.projectId
                }
                type="number"
              />
            </div>
            <div className="emissions-simulate-content-row-dropdown">
              <span>
                {endYr}
                <span className="required-star">*</span>
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={emissionsEndYeartooltip}
                ></Tooltip>
              </span>
              <Input
                errorMessage={endYearErrorMessage}
                isError={showendYearError}
                disableErrorPlaceholder={true}
                onChange={(event) => {
                  handleOnChange(event?.target?.value, "endYear");
                }}
                value={endYear}
                disabled={
                  lockedData === 1 &&
                  lockedBy !== user?.username &&
                  project?.projectId
                }
                type="number"
              />
            </div>
          </div>
        )}
        {replaceChange === "Extend" && (
          <div className="emissions-simultae-content-row">
            <div className="emissions-simulate-content-row-dropdown">
              <span>
                {actDataValue}
                <span className="required-star">*</span>
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={activityDataValueTooltip}
                ></Tooltip>
              </span>
              <Input
                onChange={(event) => {
                  handleOnChange(event?.target?.value, "activityDataValue");
                }}
                value={activityDataValue}
                errorMessage={activityDataValueErrorMessage}
                isError={isActivityDataValueError}
                type="decimal"
                disabled={shouldDisableExtendField()}
                maxLength={12}
              />
            </div>
            <div className="emissions-simulate-content-row-dropdown">
              <span>
                {actDataUnit}
                <span className="required-star">*</span>
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={activityUnitTooltip}
                ></Tooltip>
              </span>
              <MultiSelectCreatableOption
                value={activityDataUnit}
                onChange={handleActivityDataUnitChange}
                id="base-year-scope-1-2"
                avilableOptions={avilableGmpUnit}
                label={selectGMPUnit}
                overrideStrings={{
                  create: createNewGMPUnit,
                  search: SearchNewGMPUnit,
                }}
                extendModal={false}
                hasSelectAll={false}
                isCreatable={true}
                disabled={shouldDisableExtendField()}
              />
              {isActivityDataUnitError && (
                <span className="emissions-simulate-unit-validation-error">
                  {activityDataUnitErrorMessage}
                </span>
              )}
            </div>
          </div>
        )}
        {replaceChange === "Extend" && (
          <div className="emissions-simultae-content-row">
            <div className="emissions-simulate-content-row-dropdown">
              <span>
                {emisFactValue}
                <span className="required-star">*</span>
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={emissionFactorTooltip}
                ></Tooltip>
              </span>
              {unitSelected === 'Relative' && <i className="motif-overline-default-light" style={{color:'#c4c4c4', lineHeight:'100% !important', letterSpacing:'-.1px'}}>
              {EMISSION_EXTEND_RELATIVE}
</i>
              }
              <Input
                title= {project.projectType === 2 ? "Emission Factor Value is always an absolute": ""}
                disableErrorPlaceholder={true}
                onChange={(event) => {
                  handleOnChange(event?.target?.value, "emissionFactorValue");
                }}
                value={emissionFactorValue}
                isError={isEmissionFactorValueError}
                errorMessage={emissionFactorValueErrorMessage}
                type="decimal"
                disabled={shouldDisableExtendField()}
                maxLength={12}
              />
            </div>
            <div className="emissions-simulate-content-row-dropdown">
              <span>
                {emisFactorUnit}
                <span className="required-star">*</span>
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={emissionFactorunitTooltip}
                ></Tooltip>
              </span>
              { unitSelected === 'Relative' && <i className="motif-overline-default-light" style={{color:'#c4c4c4', lineHeight:'100% !important', letterSpacing:'-.1px', visibility:'hidden'}}>
                &nbsb;
</i>
}
              <Input
                disableErrorPlaceholder={true}
                onChange={(event) => {
                  handleOnChange(event?.target?.value, "emissionFactorUnit");
                }}
                value={emissionFactorUnit}
                disabled={true}
                type={"text"}
              />
            </div>
          </div>
        )}
        {editType === "Batch edit" && replaceChange === "Edit" && (
          <div className="emissions-simultae-content-row">
            <div className="emissions-simulate-content-row-dropdown">
              <span>
                {simulateValue}
                <span className="required-star">*</span>
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={emissionsValuetooltip1}
                ></Tooltip>
              </span>
              {shouldShowAbsoluteEFInfo && (
                <i className="motif-overline-default-light" style={INFO_MESSAGE_STYLE}>
                  {EMISSION_VALUE_ABSOLUTE_INFO}
                </i>
              )}
              <Input
                errorMessage={valueErrorMessage}
                isError={valueError}
                disableErrorPlaceholder={true}
                onChange={(event) => {
                  handleOnChange(event?.target?.value, "value");
                }}
                maxLength={value < 0 ? 12 : 11}
                disabled={
                  unitSelected === "" ||
                  dataType === "" ||
                  (lockedData === 1 &&
                    lockedBy !== user?.username &&
                    project?.projectId)
                }
                value={value}
                type={"decimal"}
              />
            </div>
            <div className="emissions-simulate-content-row-dropdown"></div>
          </div>
        )}
      </div>
      <div className="emissions-simulate-footer">
        {replaceChange === "Edit" && (
          <LoadingIndicatorEmbed show={simulateLoader}>
            <Button
              variant="primary-alt"
              onClick={onSimulate}
              disabled={wafErrorFlag ||
                hasBlockingUnitValidationError ||
                isSimulateBtnDisable || isChange ||
                saveLoader ||
                (lockedData === 1 &&
                  lockedBy !== user?.username &&
                  project?.projectId)
              }
            >
              <SimulateIcon /> {simulate}
            </Button>
          </LoadingIndicatorEmbed>
        )}

        <LoadingIndicatorEmbed show={saveLoader}>
          <Button
            variant="primary-alt"
            onClick={() => onSave("Save")}
            disabled={wafErrorFlag ||
              hasBlockingUnitValidationError ||
              isSimulateBtnDisable || isChange ||
              simulateLoader ||
              (lockedData === 1 &&
                lockedBy !== user?.username &&
                project?.projectId)
            }
          >
            <SaveIcon />
            {SaveBtn}
          </Button>
        </LoadingIndicatorEmbed>
      </div>
      {wafErrorFlag && <div className="waf-error-message">
        {wafErrorMessageState}
      </div>}
      <EmissionFilterModal
        isFilterOpen={isFilterOpen}
        onClose={onfilterClose}
      />
      <ExtendModal
        isModalOpen={isExtendModalOpen}
        onClose={() => onExtendClose()}
        hierarchy={trgtHrchy}
      />
    </div>
  );
}
